import { polarToCartesian as g } from "../PolarUtils.js";
function d(r) {
  var n = r.cx, s = r.cy, t = r.radius, l = r.startAngle, a = r.endAngle, e = g(n, s, t, l), u = g(n, s, t, a);
  return {
    points: [e, u],
    cx: n,
    cy: s,
    radius: t,
    startAngle: l,
    endAngle: a
  };
}
export {
  d as getRadialCursorPoints
};
